import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class Index extends Component {
  state = {
    showIcon: true
  }

  showIcon = () => this.setState({showIcon: true})

  hideIcon = () => this.setState({showIcon: false})
  render() {

    const {text, url, showBorder} = this.props

    const borderClass = showBorder
      ? "show-border"
      : ""
    return (
      <React.Fragment>
        <div className="desktop-compatible">
          <div
            className="icon-ctn"
            onMouseEnter={this.hideIcon}
            onMouseLeave={this.showIcon}
            >
            {this.state.showIcon
              ? <Link to={url}>
                  <div className={`icon ${borderClass}`}>
                    < this.props.component color={"#525c60"}/>
                  </div>
                </Link>
              : <Link to={url}>
                <div className="icon">
                  <p>{`${text.toUpperCase()}`}</p>
                </div>
              </Link>
}
          </div>
        </div>
        <div className="mobile-compatible">
          <div className="icon-ctn">
            <Link to={url}>
              <div className="icon">
                < this.props.component color={"#525c60"}/>
              </div>
            </Link>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/sidebaricon/index.js